export default {
  table: {
    shop: '商城',
    index: 'Index',
    onShelf: '上架',
    offShelf: '下架',
    soldOut: '售罄',
    total: '总数',
    view: 'View',
    subscribed: '已监测',
    nonSubscribed: '未监测',
    all: '全部',
    selectLabel: '商城监测情况',
    status: '监测状态',
    download: '下载',
  },
  favorites: {
    view: 'View',
    confirm: '确认',
    shop: '商城',
    favorites: '收藏夹',
    skuFavorites: '收藏夹中的SKU',
    detail: '详情',
    group: {
      image: '图片',
      name: '名字',
      category: '分类',
      brand: '品牌',
    },
  },
};
